import {Component, EventEmitter, Input, OnChanges, Output} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
  selector: 'informationSideBar',
  template: `
    <body>
      <div class="border-right sideBar" id="sidebar-wrapper">
        <div class="sidebar-heading">Informations</div>
          <div>
            <table>
              <thead>
              <th>Project Overview</th>
              </thead>
              <tbody>
              <tr><td class="label">Name:</td><td class="projectTitle">{{projectName}}</td></tr>
              <tr><td class="label">PId</td><td>{{pId}}</td></tr>
              <tr><td class="label">QId</td><td>{{qId}}</td></tr>
              </tbody>
            </table>
          </div>

        <div>
          <table>
            <thead>
            <th>Gallery Overview</th>
            </thead>
            <tbody>
            <tr><td class="label">Total Pictures</td><td>{{totalResp}}</td></tr>
            <tr><td class="label">Resolution</td><td></td></tr>
            </tbody>
          </table>
        </div>
        <div>
          <table>
            <thead>
            <th>Extras</th>
            </thead>
            <tbody>
            <tr *ngFor="let folder of otherFolders" class="folders list-group-item list-group-item-action">
              <td><span><img style="height:36px;width:36px;" src="../../assets/images/folder-pictures-icon.png" alt="Terminal"></span></td>
              <td><a class="folderName" style="color: white" (click)="select(folder)">{{folder}}</a></td>
            </tr>
            </tbody>
          </table>
        </div>
        </div>
    </body>
    `,
  styles: [
    `
      .sidebar-heading{font-weight:bold;}
      .folderName {
        font-family:Helvetica;
        color: white;
        font-weight: bold;
      }

      .projectTitle{overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;}
      .label{padding-left: 10px;}
      .sideBar{ height:100%;width:240px;}
      table,p{color:white;table-layout: fixed;}
      .files {
        border-left: 5px solid #17a2b8;
      }
    body{background-color: #0f0f0f;}

      .folders {
        border-left: 5px solid #B8744F;
      }

      .folders:hover {
        background-color: #63c2de;
      }

      .folders {
        background-color: #2f353a;
      }

      .files {
        background-color: #2f353a;
      }

      .files:hover {
        background-color: #63c2de;
      }

      .list-group .list-group-item:first-child {
        border-radius: 0;
      }

      .questionnaireName{color:white;}

      #custom-search-input {
        padding: 0;
        border: solid 1px #E4E4E4;
        border-radius:0;
        background-color: #f5f5f5;
      }

      #custom-search-input input {
        border: 0;
        box-shadow: none;
        font-size: 14px;
        background-color: #f5f5f5;
      }

      #custom-search-input button {
        margin: 2px 0 0 0;
        background: none;
        box-shadow: none;
        border: 0;
        color: #666666;
        padding: 0 8px 0 10px;
        border-left: solid 1px #ccc;
      }

      #custom-search-input button:hover {
        border: 0;
        box-shadow: none;
        border-left: solid 1px #ccc;
      }

      #custom-search-input .glyphicon-search {
        font-size: 14px;
      }

      #listQuestionnaires {
      }
      #questionnaire{ padding-left: 30px;}

      a {
        margin-left: 10px;
      }

      .chevron {
        position: absolute;
        top: 5px;
        left: 70%;
        padding-top: 10px;
      }`
  ]
})
export class InformationSideBarComponent implements OnChanges {

  @Input() totalResp:number;
  @Input() pId:number;
  @Input() qId:number;
  @Input() projectName:string;
  @Input() otherFolders:string[];
  @Output() selected:EventEmitter<string> = new EventEmitter();
  constructor(private _router: Router, private  _activatedRouter:ActivatedRoute) {
  }
  search: any;

  ngOnChanges() {


    console.log('ngOnChanges');
  }


  private generateLinkId(name:string) {
    return name.replace(/(\s+)/g,'');
  }

  onAdvancedSearch() {
    console.log(this._activatedRouter.parent);
    this._router.navigate(['search'],{relativeTo:this._activatedRouter});
  }

  select(folder: string) {
    this.selected.emit(folder);
  }
}
